import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LayoutDashboard, FileText, MessageSquare, CalendarClock, LogOut, ShieldCheck } from "lucide-react";

const CLIENT_NAV = [
  { to: "/portal/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/portal/documents", label: "Documents", icon: FileText },
  { to: "/portal/messages", label: "Messages", icon: MessageSquare },
  { to: "/portal/appointments", label: "Appointments", icon: CalendarClock },
];

const ADMIN_EXTRA = [
  { to: "/portal/admin", label: "Admin", icon: ShieldCheck },
];

export default function PortalShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const NAV = user?.role === "admin" ? [...CLIENT_NAV, ...ADMIN_EXTRA] : CLIENT_NAV;

  const handleLogout = async () => {
    await logout();
    nav("/portal/login");
  };

  return (
    <div className="min-h-screen flex bg-[#F9F8F6]">
      <aside data-testid="portal-sidebar" className="w-64 bg-[#0F292F] text-white flex-shrink-0 flex flex-col">
        <Link to="/" className="flex items-center gap-3 px-6 py-6 border-b border-white/10">
          <div className="w-9 h-9 bg-[#CFA968] flex items-center justify-center">
            <span className="font-serif text-[#0F292F] text-xl leading-none">H</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif text-base">H. Elliot</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/60">Client Portal</div>
          </div>
        </Link>

        <nav className="flex-1 px-3 py-6 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`portal-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-white/10 text-[#CFA968]"
                    : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon size={16} strokeWidth={1.5} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 mb-1">Signed in as</div>
            <div className="text-sm font-medium truncate">{user?.name || user?.email}</div>
            <div className="text-xs text-white/50 truncate">{user?.email}</div>
          </div>
          <button
            data-testid="portal-logout"
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-3 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
          >
            <LogOut size={16} strokeWidth={1.5} /> Sign Out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-10">{children}</div>
      </main>
    </div>
  );
}
